var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'singularity-node-titlebar-wrapper': true
  },style:(_vm.wrapperPositionStyle)},[_c('div',{staticClass:"singularity-node-titlebar",class:_vm.titlebarClasses,style:(_vm.titlebarPositionStyle)},[(_vm.isSectionElement)?_c('span',{staticClass:"singularity-node-titlebar__text"},[_vm._v(" "+_vm._s(_vm.elementTitle))]):_c('EditElementCanvasButton')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }